import { cn } from "@productlane/lib/src/cn"
import { badgeVariants } from "@productlane/ui"

// Merged through cn, or the badge base's `ring-1` outranks the variant's
// `ring-0` in the stylesheet and paints Tailwind's default blue ring.
export const contextMentionBadgeClasses = (): string =>
	cn(
		badgeVariants({
			variant: "light-gray",
			className: "max-w-[240px] cursor-default select-none",
		}),
	)
